import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-labour-job-note',
  templateUrl: './labour-job-note.component.html',
  styleUrls: ['./labour-job-note.component.css']
})
export class LabourJobNoteComponent implements OnInit {
    labourNo;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.labourNo = this.stateService.getStateParams()['labour_no'];
    }

    private async loadEdit() {
        if (!!this.labourNo) {
            this.edit = (await this.datatask.Post(536, { labour_no: this.labourNo }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(537, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    job_note: string;
    labour_no: string;
    job_machinetime_hhmm: string;
}
